module.exports = __webpack_public_path__ + "img/icon_upload@3x.a1a994e7.png";